import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useTranslation } from 'react-i18next';

import { BaseModal, ModalHeader, ModalHeaderTitle, ModalBody, ModalFooter, ModalFooterButtons, ModalSize } from '../../Fundamentals/Modal/StandardModal';
import Spinner from '../../Fundamentals/Spinner/Spinner';
import TextInput from '../../FormComponents/Input/TextInput';
import VonAuthorization from '../../VonAuthorization/VonAuthorization';

import useModal from '../../../Hooks/useModal';
import Modals from '../../../Constants/modals';
import supportLoginActions from '../../../Actions/InternalCustomerAdmin/supportLoginActions';
import commonActionsImp from '../../../Actions/commonActions';
import helpers from "../../../Utils/helpers";

import './SupportLoginModal.css';

const SupportLoginModal = ({}) => {
    const { t } = useTranslation();
    const { closeModal } = useModal();

    const dispatch = useDispatch();
    const actions = bindActionCreators(supportLoginActions, dispatch);
    const commonActions = bindActionCreators(commonActionsImp, dispatch);

    const [result, setResult] = useState('');
    const [codeInputValue, setCodeInputValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [hasCodeBeenClicked, setHasCodeBeenClicked] = useState(false);

    const showResultSection = isLoading || result;

    const onCodeSendClick = () => {
        setIsLoading(true);

        actions.redeemSupportCode(codeInputValue, (result) => {
            if (result) {
                setHasCodeBeenClicked(false);
                setResult(result.token);
            }

            setIsLoading(false);
        });
    };

    return (
        <BaseModal size={ModalSize.LARGE}>
            <VonAuthorization onCancel={closeModal} redirectUrl={`?openModal=${Modals.SupportLogin}`}>
                <ModalHeader onclose={closeModal}>
                    <ModalHeaderTitle>{t('supportLogInModal.title')}</ModalHeaderTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="support-login-modal">
                        <div className="information-text-container bg-primary p-16 mb-16 rounded-8">
                            <p className="bold">{t('supportLogInModal.instructionsTitle')}</p>
                            <p className="formatted-text"> {helpers.parseText(t('supportLogInModal.instructions'))}</p>
                            <p className="bold">{t('supportLogInModal.instructionsBold')}</p>
                        </div>

                        <TextInput
                            label={t('supportLogInModal.supportCode')}
                            value={codeInputValue}
                            onChange={(event) => setCodeInputValue(event.target.value)}
                            onBlur={(event) => setCodeInputValue(event.target.value.trim())}
                        />

                        <button type="button" className="btn btn-primary" onClick={onCodeSendClick}>
                            {t('supportLogInModal.getAction')}
                        </button>

                        {showResultSection && (
                            <div className={`result-link-container mt-16 p-16 rounded-8 ${isLoading ? '' : 'bg-primary '}`}>
                                {isLoading ? (
                                    <Spinner />
                                ) : (
                                    <>
                                        {result && (
                                            <div>
                                                <p className="bold">{t('supportLogInModal.resultTitle')}</p>
                                                <a href={result} className={hasCodeBeenClicked ? 'disabled' : ''} target={'_blank'} onClick={() => setHasCodeBeenClicked(true)}>
                                                    {result}
                                                </a>
                                                <span
                                                    className="vismaicon vismaicon-copy copy-icon"
                                                    title={t('supportLogInModal.copyToClipBoardMessage')}
                                                    onClick={() => commonActions.copyToClipboard(t('supportLogInModal.copyToClipBoardTitle'), result)}
                                                />

                                                {hasCodeBeenClicked && <p className="mt-16">{t('supportLogInModal.linkHasBeenUsed')}</p>}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ModalFooterButtons onClose={closeModal}></ModalFooterButtons>
                </ModalFooter>
            </VonAuthorization>
        </BaseModal>
    );
};

export default SupportLoginModal;
